import styled from "styled-components";

export const Textarea = styled.textarea`
	color: #637381;
	border-radius: 7px;
	border: 1px solid #dfe4ea;
	padding: 8px 15px;
	width: 100%;
	font-size: 0.875rem !important;
	&:hover {
		border-color: #bcbcbc !important;
		outline: none;
	}
	&:focus {
		border-color: #bcbcbc !important;
		outline: none;
	}

	&:focus-visible {
		border-color: #bcbcbc !important;
		outline: none;
	}
	&::placeholder {
		font-size: 0.875rem !important;
		opacity: 1 !important;
		pointer-events: none;
		color: #bcbcbc !important;
	}
	box-shadow: none !important;

	&:disabled {
	-webkit-appearance: none !important;
	appearance: none !important;
	background-color: #f3f3f3 !important;
	background-image: linear-gradient(to right, #f3f3f3, #f3f3f3) !important;
	color: rgb(99, 115, 129) !important;
	-webkit-text-fill-color: rgb(99, 115, 129) !important;
	opacity: 1 !important;
	pointer-events: none;
}
`;
